import { createAction, props, Action } from '@ngrx/store';
import {
  ApiError,
  BasketCheckoutRequest,
  BasketCheckoutOperationResponse,
} from '../client/src';

export const checkoutBasket = createAction('[Checkout] Checkout Basket');

export const CHECKOUT_BASKET_TYPE = '[Checkout] Checkout Basket API';
export const checkoutAPI_checkoutBasket = createAction(
  CHECKOUT_BASKET_TYPE,
  props<{ request: BasketCheckoutRequest; basketId: string }>()
);

export const checkoutAPI_checkoutBasketSuccess = createAction(
  `${CHECKOUT_BASKET_TYPE} Success`,
  props<{ response: BasketCheckoutOperationResponse }>()
);

export const checkoutAPI_checkoutBasketFailure = createAction(
  `${CHECKOUT_BASKET_TYPE} Failure`,
  props<{ error?: string | ApiError; retryAction?: Action }>()
);
